module.exports = __webpack_public_path__ + "img/contributionBlue.fd620efb.png";